import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedName } from '../../../iwIntlProvider/FormattedName';
import { EditSVG } from '../../../svgComponents/editSVG';
import { CheckShieldSVG } from '../../../svgComponents/checkShieldSVG';
import messages from './PersonCard.messages';
import { Text } from '@ui';

export class PersonCard extends Component {
    renderRoles() {
        const { roles } = this.props;
        if (!roles) return null;

        const filtered_roles = roles.filter(
            (role) => role !== 'authorised_person'
        );
        return filtered_roles.map((role, i) => {
            if (i + 1 === filtered_roles.length) {
                return <FormattedMessage key={role} {...messages[role]} />;
            }

            return (
                <FormattedMessage key={role} {...messages[role]}>
                    {(text) => `${text}, `}
                </FormattedMessage>
            );
        });
    }

    render() {
        const { firstName, lastName, onClick, isGuarantor } = this.props;
        const roles = this.renderRoles();

        return (
            <div className="rounded-md bg-structure-100 shadow-black-s">
                <div className="space-y-s p-l">
                    <div className="flex justify-between">
                        <FormattedName
                            firstName={firstName}
                            lastName={lastName}
                        />
                        <button
                            className="border-none bg-transparent fill-primary-10 stroke-primary-10 hover:cursor-pointer"
                            data-testid="edit_person"
                            onClick={onClick}
                        >
                            <EditSVG className="h-4 w-4" />
                        </button>
                    </div>
                    <div
                        className="text-s font-light"
                        data-testid="person-roles"
                    >
                        {roles}
                    </div>
                </div>
                {isGuarantor && (
                    <div className="flex p-l">
                        <CheckShieldSVG className="mr-2xs" />
                        <Text className="text-s font-medium">
                            <FormattedMessage {...messages.personalGuarantor} />
                        </Text>
                    </div>
                )}
            </div>
        );
    }
}
